import camelcaseKeys from "camelcase-keys";
import { GetVehicleTypesResponse } from "@/redux/slices/vehicle/types";
import { GetVehicleTypesRawResponse } from "./types";

export const transformGetVehicleTypesResponse = (response: GetVehicleTypesRawResponse): GetVehicleTypesResponse => {
  return {
    vehicleTypes: response._embedded.category.map((category) => camelcaseKeys(category, { deep: true })),
    page: {
      current: response.page,
      count: response.page_count,
      size: response.page_size,
      total: response.total_items,
    },
  };
};
